/* Arabic presentation only. Stored content and every original character stay unchanged. */
(function () {
  'use strict';

  function isArabic() {
    return /^ar(?:-|$)/i.test(document.documentElement.lang || '');
  }
  if (!isArabic()) return;

  function initialize() {
    if (!isArabic()) return;
    var root = document.getElementById('MainContent');
    if (!root || root.__blArabicTechnicalBidiInitialized) return;
    root.__blArabicTechnicalBidiInitialized = true;

    /* MainContent is the verified theme main landmark. This also covers product
       and collection headings/cards without touching header/footer navigation. */
    var excluded = [
      'script', 'style', 'noscript', 'template', 'code', 'pre', 'kbd', 'samp',
      'svg', 'math', 'iframe', 'form', 'input', 'textarea', 'select', 'option',
      'button', 'nav', 'header', 'footer', 'bdi', '[dir="ltr" i]',
      '[data-bl-ar-technical]', '[contenteditable]:not([contenteditable="false"])',
      '.price', '.money', '.compare-at-price', '.unit-price', '.price-container',
      '.product-price', '[data-product-price]', '[data-price]',
      '.localization-form', 'localization-form', '.blc-wrap',
      '#pc--optOutFormContainer'
    ].join(',');

    var number = '\\d+(?:[.,]\\d+)?';
    var range = number + '(?:\\s*[–—−-]\\s*' + number + ')?';
    var unit = '(?:mm|cm|lm|lx|lux|kWh|kW|mA|Hz|kg|ft|W|V|A|K|m|g|°C|°F|°|%)';
    var scalar = '(?:(?:AC|DC)\\s*)?' + range + '\\s*' + unit;
    var alternatives = [
      /* Repeated units belong to one range or dimension, e.g. 5W–50W or
         360mm × 26mm. Separate isolates would reverse the endpoint order. */
      scalar + '(?:\\s*[–—−x×-]\\s*' + scalar + ')+',
      /* Keep a whole CCT/voltage/power option sequence together. */
      scalar + '(?:\\s*/\\s*' + scalar + ')+',
      /* Dimensions, beam axes and explicit numeric multiplication. */
      number + '(?:\\s*°)?(?:\\s*[x×]\\s*' + number + '(?:\\s*°)?){1,3}' +
        '(?:\\s*' + unit + ')?(?:\\s*=\\s*' + scalar + ')?',
      /* CRI plus/rating notation must not move its plus sign. */
      'CRI\\s*(?:[:≥>]\\s*)?' + number + '(?:\\s*\\+)?',
      scalar + '(?:\\s*±\\s*' + number + '\\s*%)?',
      '(?:IP|M)' + number
    ];
    /* The patterns contain only numbers, Latin technical prefixes/units and
       specification punctuation. They cannot consume an Arabic word. */
    var pattern = new RegExp('(?<![A-Za-z0-9])(?:' + alternatives.join('|') + ')(?![A-Za-z0-9])', 'g');

    function eligible(node) {
      var parent = node.parentElement;
      if (!parent || !node.nodeValue || !/\d/.test(node.nodeValue)) return false;
      if (parent.closest(excluded)) return false;
      /* Respect an explicit technical isolate. Browsers give many ordinary RTL
         block elements unicode-bidi:isolate by default; that alone must not
         suppress isolation of a Latin specification inside the paragraph. */
      for (var el = parent; el && el !== root; el = el.parentElement) {
        var computed = window.getComputedStyle(el);
        if (/isolate/.test(el.style.unicodeBidi) ||
            (computed.direction === 'ltr' && /isolate/.test(computed.unicodeBidi))) return false;
      }
      return true;
    }

    function isolate(node) {
      var text = node.nodeValue;
      pattern.lastIndex = 0;
      var matches = Array.from(text.matchAll(pattern));
      if (!matches.length) return;
      var fragment = document.createDocumentFragment();
      var cursor = 0;
      matches.forEach(function (match) {
        if (match.index > cursor) fragment.appendChild(document.createTextNode(text.slice(cursor, match.index)));
        var bdi = document.createElement('bdi');
        bdi.setAttribute('dir', 'ltr');
        bdi.setAttribute('data-bl-ar-technical', 'true');
        bdi.className = 'bl-ar-technical-spec';
        bdi.style.unicodeBidi = 'isolate';
        bdi.style.display = 'inline-block';
        bdi.style.whiteSpace = 'nowrap';
        bdi.textContent = match[0];
        fragment.appendChild(bdi);
        cursor = match.index + match[0].length;
      });
      if (cursor < text.length) fragment.appendChild(document.createTextNode(text.slice(cursor)));
      node.parentNode.replaceChild(fragment, node);
    }

    var observer;
    var queued = false;
    function process() {
      queued = false;
      if (!isArabic() || !root.isConnected) {
        if (observer) observer.disconnect();
        return;
      }
      if (observer) observer.disconnect();
      try {
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        var nodes = [];
        var node;
        while ((node = walker.nextNode())) {
          if (eligible(node)) nodes.push(node);
        }
        nodes.forEach(isolate);
      } finally {
        if (observer && isArabic() && root.isConnected) {
          observer.observe(root, { childList: true, characterData: true, subtree: true });
        }
      }
    }

    observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(process);
    });
    process();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

